module.exports = __webpack_public_path__ + "img/icon_map_0_off_011.3d07062a.png";